// Tiny context to propagate sidebar-collapsed state from AppShell to pages
// that need to adjust their own header layout (e.g. add left padding to
// make room for the floating "expand sidebar" button).

import { createContext, useContext } from "react";

interface SidebarCtx {
  collapsed: boolean;
  toggle: () => void;
}

const Ctx = createContext<SidebarCtx>({ collapsed: false, toggle: () => {} });

export const SidebarProvider = Ctx.Provider;
export function useSidebar(): SidebarCtx {
  return useContext(Ctx);
}
